export const damagingNameConstants = {
  // Search damaging party names
  SEARCH_DAMAGING_REQUEST: "DAMAGING_NAME_SEARCH_REQUEST",
  SEARCH_DAMAGING_SUCCESS: "DAMAGING_NAME_SEARCH_SUCCESS",
  SEARCH_DAMAGING_FAILURE: "DAMAGING_NAME_SEARCH_FAILURE",

  // Search by claim ID
  SEARCH_BY_CLAIM_REQUEST: "DAMAGING_NAME_SEARCH_BY_CLAIM_REQUEST",
  SEARCH_BY_CLAIM_SUCCESS: "DAMAGING_NAME_SEARCH_BY_CLAIM_SUCCESS",
  SEARCH_BY_CLAIM_FAILURE: "DAMAGING_NAME_SEARCH_BY_CLAIM_FAILURE",

  // Search in claims
  SEARCH_CLAIMS_REQUEST: "DAMAGING_NAME_SEARCH_CLAIMS_REQUEST",
  SEARCH_CLAIMS_SUCCESS: "DAMAGING_NAME_SEARCH_CLAIMS_SUCCESS",
  SEARCH_CLAIMS_FAILURE: "DAMAGING_NAME_SEARCH_CLAIMS_FAILURE",

  // Search in contacts
  SEARCH_CONTACTS_REQUEST: "DAMAGING_NAME_SEARCH_CONTACTS_REQUEST",
  SEARCH_CONTACTS_SUCCESS: "DAMAGING_NAME_SEARCH_CONTACTS_SUCCESS",
  SEARCH_CONTACTS_FAILURE: "DAMAGING_NAME_SEARCH_CONTACTS_FAILURE",

  // Delete damaging parties
  DELETE_DAMAGING_REQUEST: "DAMAGING_NAME_DELETE_REQUEST",
  DELETE_DAMAGING_SUCCESS: "DAMAGING_NAME_DELETE_SUCCESS",
  DELETE_DAMAGING_FAILURE: "DAMAGING_NAME_DELETE_FAILURE",

  // Update claim names
  UPDATE_CLAIMS_REQUEST: "DAMAGING_NAME_UPDATE_CLAIMS_REQUEST",
  UPDATE_CLAIMS_SUCCESS: "DAMAGING_NAME_UPDATE_CLAIMS_SUCCESS",
  UPDATE_CLAIMS_FAILURE: "DAMAGING_NAME_UPDATE_CLAIMS_FAILURE",

  // Update contact names
  UPDATE_CONTACTS_REQUEST: "DAMAGING_NAME_UPDATE_CONTACTS_REQUEST",
  UPDATE_CONTACTS_SUCCESS: "DAMAGING_NAME_UPDATE_CONTACTS_SUCCESS",
  UPDATE_CONTACTS_FAILURE: "DAMAGING_NAME_UPDATE_CONTACTS_FAILURE",

  DAMAGING_NAME_CLEAR: "DAMAGING_NAME_CLEAR",
};
